/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { AdminNewsListNewsForPlannerFragmentDoc } from '../../features/adminNews/components/AdminNewsList/AdminNewsList.generated';
export type DashboardPageNewsSectionNewsForPlannerFragment = { newsForPlanner: { edges: Array<{ node: { id: string, title: string, body: string, publishedAt: TimeString } }> } };

export const DashboardPageNewsSectionNewsForPlannerFragmentDoc = gql`
    fragment DashboardPageNewsSectionNewsForPlanner on Query {
  newsForPlanner(first: 1) {
    edges {
      node {
        ...AdminNewsListNewsForPlanner
      }
    }
  }
}
    ${AdminNewsListNewsForPlannerFragmentDoc}`;